export default __webpack_public_path__ + "static/heart_benefits-6c72af2ce0aaf4feedd405ee30d517b9.png";